import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const tabPanelCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:block}.tab-panel{padding-block:var(--tt-panel-padding-block)}";

let id = 0;
const TabPanel = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.componentId = `tab-panel-${++id}`;
    this.name = '';
    this.active = false;
  }
  render() {
    return (
    // If the user didn't provide an ID, we'll set one so we can link tabs and tab panels with aria labels
    h(Host, { id: this.element.id || this.componentId, style: { display: this.active ? 'block' : 'none' } }, h("div", { part: "base", class: "tab-panel", role: "tabpanel", "aria-selected": this.active ? 'true' : 'false', "aria-hidden": this.active ? 'false' : 'true' }, h("slot", null))));
  }
  get element() { return this; }
  static get style() { return tabPanelCss; }
}, [1, "tt-tab-panel", {
    "name": [1],
    "active": [516]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-tab-panel"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-tab-panel":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TabPanel);
      }
      break;
  } });
}

const TtTabPanel = TabPanel;
const defineCustomElement = defineCustomElement$1;

export { TtTabPanel, defineCustomElement };
